module.exports = __webpack_public_path__ + "assets/battery_swap_in_progress.73190759.svg";